<ion-header>
  <ion-toolbar color="primary">
    <ion-buttons slot="start">
      <ion-back-button defaultHref="/edible"></ion-back-button>
    </ion-buttons>
    <ion-title>{{selectedFood.name}}</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content fullscreen color="lightmimbo">
  <div class="ion-text-center ion-padding" *ngIf="isLoading">
    <ion-spinner color="primary"></ion-spinner>
  </div>
  <div *ngIf="!isLoading" class="ion-padding">
    <ion-grid *ngIf="selectedFood">
      <ion-row>
        <ion-col sizeXl="10" offsetXl="1">
          <ion-segment value="dogs" [(ngModel)]="filter" (ionChange)="loadDetails()">
            <ion-segment-button value="dogs">
              <ion-label>
                Dogs
              </ion-label>
            </ion-segment-button>
            <ion-segment-button value="cats">
              <ion-label>
                Cats
              </ion-label>
            </ion-segment-button>
          </ion-segment>
        </ion-col>
      </ion-row>
    </ion-grid>
    <ion-card class="ion-text-center post">
      <img [src]="imageUrl" class="image" />
      <ion-card-header>
        <ion-card-title color="darkmimbo">Can {{filter.toLowerCase()}} eat
          {{selectedFood.name.toLowerCase()}}?</ion-card-title>
      </ion-card-header>
      <ion-card-content>
        <ion-label [color]="answerClass">
          <h1>{{answerText}}</h1>
        </ion-label>
      </ion-card-content>
    </ion-card>
    <ion-grid>
      <ion-row>
        <ion-col sizeMd="10" offsetMd="1" sizeXl="8" offsetXl="2" class="ion-text-center">
          <h2>
            <u><ion-text color="darkmimbo">What You Should Know </ion-text></u>
          </h2>
          <ion-text color="darkmimbo">
            <h4 *ngIf="filter == 'dogs'">{{selectedFood.dogNotes}}</h4>
            <h4 *ngIf="filter == 'cats'">{{selectedFood.catNotes}}</h4>
          </ion-text>
        </ion-col>
      </ion-row>
    </ion-grid>
  </div>
</ion-content>